import { Code, Modal } from "components";
import { useNotification, useViewport } from "hooks";
import { FC, useMemo } from "react";
import { FlexContainer } from "styled/Box";
import { Button } from "styled/Buttons";

interface ErrorCodeModalProps {
  error: string | null;
  onClose: () => void;
}

export const ErrorCodeModal: FC<ErrorCodeModalProps> = ({ error, onClose }) => {
  const { openNotification } = useNotification();

  const { isMobile } = useViewport();

  const handleCopyToClipBoard = async () => {
    if (!error) {
      openNotification({ message: "Something went wrong", type: "error" });

      return;
    }

    try {
      await navigator.clipboard.writeText(error);
      openNotification({ id: error, message: "Copied to clipboard" });
    } catch (error) {
      openNotification({ message: "Something went wrong", type: "error" });
    }
  };

  const getErrorObject = useMemo(() => {
    if (!error) return {};

    const errorObject = JSON.parse(error);

    try {
      errorObject.body = JSON.parse(errorObject.body);
    } catch (e) {
      console.warn("is not valid JSON");
    }

    return errorObject;
  }, [error]);

  return (
    <Modal open={!!error} onClose={onClose} title="Error Code">
      <Code json={getErrorObject} />

      <FlexContainer
        $fullwidth
        $align="center"
        $justify="flex-end"
        $gap={8}
        $padding="24px 0 0"
        $column={isMobile}
      >
        <Button.Heading $fullWidth={isMobile} onClick={handleCopyToClipBoard}>
          Copy to Clipboard
        </Button.Heading>
      </FlexContainer>
    </Modal>
  );
};
